export const ProcessedIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16.153" height="16.007" viewBox="0 0 16.153 16.007">
            <g id="Icon_feather-check-circle" data-name="Icon feather-check-circle" transform="translate(-2.31 -2.338)">
                <path id="Path_5859" data-name="Path 5859" d="M17.756,9.694v.679A7.378,7.378,0,1,1,13.381,3.63" transform="translate(0 0)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                <path id="Path_5860" data-name="Path 5860" d="M23.091,6l-7.378,7.385L13.5,11.172" transform="translate(-5.336 -1.529)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            </g>
        </svg>
    )
}